const validate = (txidCode: string): boolean => txidCode.length === 8 && !txidCode.match(/[^A-Z0-9]+/g)

export default validate
